/**
 * Show duration in seconds as Xm Xs / Xh Xm / Xd Xh
 *
 * @param {number} durationInSeconds - The duration to in seconds
 *
 * @example
 * console.log(toMinutes(244)); // 4m 4s
 * console.log(toMinutes(4200)); // 1h 10m
 * console.log(toMinutes(90000)); // 1d 1h
 */
const toMinutes = (durationInSeconds: number) => {
  const minutes = Math.floor(durationInSeconds / 60);

  if (minutes < 60) {
    const remainingSeconds = Math.ceil(durationInSeconds - minutes * 60);

    return `${minutes}m ${remainingSeconds}s`;
  }
  const hours = Math.floor(minutes / 60);

  if (hours < 24) {
    const remainingMinutes = Math.ceil(minutes - hours * 60);

    return `${hours}h ${remainingMinutes}m`;
  }
  const days = Math.floor(hours / 24);
  const remainingHours = Math.ceil(hours - days * 24);

  return `${days}d ${remainingHours}h`;
};

export default toMinutes;
